const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-vendor-on-board'] = {
        c: () => require('partner/modules/dobbies-vendor-on-board/dobbies-vendor-on-board.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-vendor-on-board',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-vendor-on-board'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-vendor-on-board|dobbies-vendor-on-board'] = {
                c: () => require('partner/modules/dobbies-vendor-on-board/dobbies-vendor-on-board.view.tsx'),
                cn: '__local__-__local__-dobbies-vendor-on-board'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };